// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import EstoqueProdutoMovimentacaoFormController from "../vanila/estoque/produto/movimentacao/vinculo_movimentacoes_form/estoque_produto_movimentacao_form_controller"
import VinculoMovimentacoesListagemController from "../vanila/estoque/produto/movimentacao/vinculo_movimentacoes_form/vinculo_movimentacoes_listagem_controller"
import VinculoMovimentacaoController from "../vanila/estoque/produto/movimentacao/vinculo_movimentacoes_form/vinculo_movimentacao_controller"
import VerificacaoAcessoCooldownController from "../vanila/verificacao_acesso_controller"

application.register("estoque-produto-movimentacao-form", EstoqueProdutoMovimentacaoFormController)
application.register("vinculo-movimentacoes-listagem", VinculoMovimentacoesListagemController)
application.register("vinculo-movimentacao", VinculoMovimentacaoController)
application.register("verificacao-acesso-cooldown", VerificacaoAcessoCooldownController)
